import { Users, Bike, MapPin, Leaf } from "lucide-react";
import { useTranslation } from "react-i18next";
import Reveal from "../Reveal";

const CARD_KEYS = ["groups", "ebikes", "pickup", "wellness"];
const ICONS = { groups: Users, ebikes: Bike, pickup: MapPin, wellness: Leaf };

export default function WhyUs() {
  const { t } = useTranslation();
  return (
    <section className="bg-bone py-24 lg:py-40" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end mb-16 lg:mb-24">
          <div className="md:col-span-8">
            <div className="text-xs uppercase tracking-wider-3 text-moss mb-6 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-moss" />
              {t("why.eyebrow")}
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl text-forest leading-[1.04]">
              {t("why.title_a")}<br/><span className="italic">{t("why.title_b")}</span>
            </h2>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-bone-deep border border-bone-deep">
          {CARD_KEYS.map((key, i) => {
            const Icon = ICONS[key];
            return (
              <Reveal key={key} delay={i * 100} className="bg-bone p-8 lg:p-10 min-h-[280px] flex flex-col group hover:bg-forest hover:text-bone transition-colors duration-700">
                <Icon className="w-7 h-7 text-forest group-hover:text-bone transition-colors stroke-[1.25]" />
                <h3 className="font-display text-3xl mt-8 text-forest group-hover:text-bone transition-colors">{t(`why.cards.${key}.title`)}</h3>
                <p className="text-sm text-muted-foreground group-hover:text-bone/80 mt-4 leading-relaxed">{t(`why.cards.${key}.text`)}</p>
                <div className="mt-auto pt-6 text-xs uppercase tracking-wider-3 text-moss group-hover:text-bone/60">0{i+1}</div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
